import styled from 'styled-components';

export const PublicScheduleContainer = styled.div`
  min-height: 100vh;
  padding: 32px 20px;
  background:
    radial-gradient(
      circle at top left,
      rgba(110, 185, 160, 0.22),
      transparent 32%
    ),
    radial-gradient(
      circle at top right,
      rgba(53, 109, 159, 0.18),
      transparent 30%
    ),
    linear-gradient(180deg, #f6fbf8 0%, #eef5fb 100%);

  @media (max-width: 640px) {
    padding: 12px 10px 20px;
  }
`;

export const PublicScheduleShell = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(280px, 420px) minmax(320px, 1fr);
  gap: 24px;
  align-items: start;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const PublicScheduleHero = styled.section`
  position: sticky;
  top: 24px;
  padding: 28px;
  border-radius: 28px;
  color: #ffffff;
  background: linear-gradient(145deg, #155d4b 0%, #1f725f 52%, #356d9f 100%);
  box-shadow: 0 24px 60px rgba(21, 93, 75, 0.22);

  @media (max-width: 960px) {
    position: static;
    order: 2;
    padding: 18px 16px;
    border-radius: 20px;

    .hero-badge {
      margin-bottom: 12px;
      font-size: 11px;
    }

    h1 {
      font-size: 26px;
      line-height: 1.08;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .hero-badge {
    display: inline-flex;
    padding: 8px 14px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin-bottom: 18px;
  }

  h1 {
    margin: 0 0 12px;
    color: #ffffff;
    font-size: clamp(30px, 4vw, 46px);
    line-height: 1.02;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.84);
    font-size: 16px;
    line-height: 1.7;
  }
`;

export const PublicScheduleHighlights = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 24px;

  .highlight-item {
    padding: 14px 16px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.14);
  }

  .highlight-label {
    display: block;
    margin-bottom: 4px;
    color: rgba(255, 255, 255, 0.66);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .highlight-value {
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
  }

  @media (max-width: 960px) {
    display: none;
  }
`;

export const PublicScheduleMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 22px;

  .metric-card {
    padding: 14px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.16);
  }

  .metric-label {
    display: block;
    margin-bottom: 6px;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.66);
    font-weight: 700;
  }

  .metric-value {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
  }

  @media (max-width: 560px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));

    .metric-card {
      padding: 10px;
      border-radius: 12px;
    }

    .metric-label {
      font-size: 9px;
      margin-bottom: 2px;
    }

    .metric-value {
      font-size: 14px;
    }
  }
`;

export const PublicScheduleSummary = styled.div`
  margin-top: 22px;
  padding: 18px;
  border-radius: 22px;
  background: rgba(7, 31, 25, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.1);

  .summary-title {
    display: block;
    margin-bottom: 14px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .summary-list {
    display: grid;
    gap: 10px;
  }

  .summary-item {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 14px;
  }

  .summary-label {
    color: rgba(255, 255, 255, 0.66);
  }

  .summary-value {
    color: #fff;
    text-align: right;
    font-weight: 600;
  }

  @media (max-width: 960px) {
    margin-top: 12px;
    padding: 12px;
    border-radius: 14px;

    .summary-title {
      margin-bottom: 8px;
      font-size: 10px;
    }

    .summary-list {
      gap: 8px;
    }

    .summary-item {
      font-size: 12px;
      gap: 10px;
    }
  }
`;

export const PublicScheduleFormCard = styled.section`
  padding: 28px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(21, 93, 75, 0.08);
  box-shadow: 0 24px 60px rgba(46, 86, 122, 0.12);

  .card-title {
    margin: 0 0 8px;
    color: #143b33;
    font-size: 28px;
    line-height: 1.1;
  }

  .card-subtitle {
    margin: 0 0 28px;
    color: #5b6f68;
    font-size: 15px;
    line-height: 1.6;
  }

  .ant-form-item-label > label {
    color: #1d4f45;
    font-weight: 600;
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-picker,
  .ant-select-selector {
    min-height: 44px;
    border-radius: 12px;
  }

  .ant-input-textarea textarea {
    min-height: 108px;
    border-radius: 12px;
  }

  .section-title {
    display: block;
    margin-bottom: 14px;
    color: #1d4f45;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .availability-card {
    margin-bottom: 24px;
    padding: 18px;
    border-radius: 18px;
    background: linear-gradient(180deg, #fbfdfc 0%, #f2f7f5 100%);
    border: 1px solid rgba(21, 93, 75, 0.08);
  }

  .availability-grid {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .availability-item {
    padding: 12px 14px;
    border-radius: 14px;
    background: #fff;
    border: 1px solid rgba(21, 93, 75, 0.08);
  }

  .availability-empty {
    padding: 14px 16px;
    border-radius: 14px;
    background: #f6ffed;
    border: 1px solid #d9f7be;
    color: #237804;
    font-weight: 600;
  }

  .availability-time {
    display: block;
    margin-bottom: 4px;
    color: #133b32;
    font-weight: 700;
  }

  .availability-meta {
    color: #64766f;
    font-size: 13px;
  }

  @media (max-width: 640px) {
    .availability-grid {
      grid-template-columns: 1fr;
    }

    .availability-card {
      margin-bottom: 16px;
      padding: 12px;
      border-radius: 12px;
    }

    .availability-item {
      padding: 10px 12px;
      border-radius: 10px;
    }

    .availability-time {
      font-size: 13px;
    }

    .availability-meta {
      font-size: 12px;
    }
  }

  .submit-section .ant-alert {
    border-radius: 12px;
  }

  @media (max-width: 640px) {
    .submit-section {
      position: sticky;
      bottom: 8px;
      background: rgba(255, 255, 255, 0.95);
      padding: 10px;
      border: 1px solid rgba(21, 93, 75, 0.1);
      border-radius: 12px;
      backdrop-filter: blur(6px);
      z-index: 3;
    }

    .submit-section .ant-alert {
      margin-bottom: 0;
      font-size: 12px;
    }
  }
`;

export const SuccessCard = styled.div`
  padding: 10px 0 4px;

  .success-pill {
    display: inline-flex;
    padding: 8px 14px;
    border-radius: 999px;
    background: #eaf7ef;
    color: #1b7a4d;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  h2 {
    margin: 16px 0 10px;
    color: #143b33;
    font-size: 30px;
    line-height: 1.1;
  }

  p {
    margin: 0;
    color: #61736d;
    line-height: 1.7;
  }
`;

export const SuccessGrid = styled.div`
  display: grid;
  gap: 14px;
  margin: 22px 0 28px;

  .success-item {
    padding: 16px 18px;
    border-radius: 18px;
    background: linear-gradient(180deg, #fbfdfb 0%, #f2f8f5 100%);
    border: 1px solid rgba(21, 93, 75, 0.1);
  }

  .success-label {
    display: block;
    margin-bottom: 5px;
    color: #6a7b74;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .success-value {
    color: #133b32;
    font-size: 16px;
    font-weight: 600;
  }
`;
